
import Multiselect from 'vue-multiselect';
import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/en';
import moment from 'moment';

export default {
    name: "FilterDropdownMobile",
    components: {
        Multiselect,
    },
    props: {
        filterTitle: {
            type: String,
            required: true,
            default: ''
        },
        filterPlaceholder: {
            type: String,
            required: true,
            default: ''
        },
        filterDatePeriod: {
            type: Array,
            required: false,
            default: () => {}
        },
        filterOptions: {
            type: Array,
            required: false,
            default: () => [],
        },
        mode: {
            type: String,
            required: false,
            default: 'default',
        },
        filterAvailableDays: {
          type: Number,
          required: false,
          default: 0, // 0 = no disable dates; eg. 31 = only available for 31 days
        }
    },
    data() {
        return {
            value1: [moment().format('YYYY-MM-DD'), moment().add(6, 'days').format('YYYY-MM-DD')],
            active: false,
            // startDate: [],
            // endDate: [],
            storeMode: this.$store.getters['modal/showDisplayMobileFilter'].mode,
            pickedStartDate: null,
        };
    },
    watch: {
        filterDatePeriod(newValue) {
            this.value1 = newValue;
        },
        value1(newValue, oldValue) {
          if ( newValue[1] !== null ) {
            this.pickedStartDate = null;
          }
        },
    },
    mounted () {
        this.value1 = this.filterDatePeriod;

        this.$nextTick(() => {
            const type = this.mode.split(' ');
            const storeMode = this.$store.getters['modal/showDisplayMobileFilter'].mode;
            if (type[0] == storeMode) {
                this.active = true;
            }


            this.$watch(
            () => {
                return this.$refs.datepicker.popupVisible;
            },
          (newValue) => {
            if (newValue ==true) {
                this.active = true;
            }
            if (newValue == false) {
                this.active = false;
            }
          }
        )
        })
    },
    methods: {
        openDatePicker() {
            // this.$refs.datepicker.openPopup();
            this.active = true;
            // this.active = this.$refs.datepicker.popupVisible;
            // this.active = !this.active;
        },
        closeDatePicker() {
            // this.$refs.datepicker.closePopup();
            // this.active = this.$refs.datepicker.popupVisible;
            this.active = false;

            window.scrollTo(0, 0);
            // this.active = !this.active;
        },
        // toggleDatePicker() {
        //     this.active = !this.active;
        //     // window.scrollTo(0, 0);
        // },
        formatDate(date) {
          return moment(date).format('YYYY-MM-DD');
        },
        resetDisableDate() {
          this.pickedStartDate = null;
        },
        handleCloseDatepicker() {
          window.scrollTo(0, 0);
          this.pickedStartDate = null;
          this.resetDisableDate();
        },
        handleAvailablePeriod(date) {
          if ( this.filterAvailableDays <= 0 ) return;
          this.pickedStartDate = this.formatDate(date);
        },
        disabledDates(date) {
          const start = moment().startOf('day');
          if ( this.filterAvailableDays <= 0 && this.pickedStartDate === null ) {
            if (moment(date).isBefore(start, 'days')) return date < start - 1;
          } else {
            const availableDatesStart = moment(this.pickedStartDate).subtract(this.filterAvailableDays - 1, 'days');
            const availableDatesEnd = moment(this.pickedStartDate).add(this.filterAvailableDays - 1, 'days');
            return date < start - 1 || date < availableDatesStart - 1 || date > availableDatesEnd;
          }
        },
        localizationDate(date, lang, format) {
          return moment(date).locale(lang ? lang : 'en').format(format ? format : 'LL');
        }
    },
    computed: {
        getClass() {
            if (this.active) {
                return 'active mx-input-custom'
            }
            return 'mx-input-custom'
        },
        getLang() {
            return this.$i18n.locale === 'zh-HK'? 'zh-cn' : 'en';
        },
    },
    updated() {
        this.$emit('date', this.value1)
    }
}
